export const isAuthenticated = () => {
    if(localStorage.getItem('usertoken')){
        return localStorage.getItem('usertoken')
    }
    return false

}

